// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UdHCL","contentContainer":"styles_contentContainer__+Qvri","iconContainer":"styles_iconContainer__UMJpv"};